export const MOCK_HOST =
  'https://mock-preview-consweb.pnd.dev.aws.sg.singtelgroup.net';
